module.exports = __webpack_public_path__ + "static/media/bg_confirm_hero.1a89cedd.jpg";